<template>
  <div class="stopSetting">
    <el-dialog
      title="停诊设置"
      :visible.sync="visible"
      width="900px"
      top="20vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content">
        <div class="header">
          <el-button type="primary" @click="addStop">新增停诊</el-button>
        </div>
        <div class="table">
          <el-table :data="list" max-height="440">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="停诊日期" min-width="180">
              <template slot-scope="scope">
                <div>{{ new Date(scope.row.startTime).Format('yyyy.MM.dd') }}至{{ new Date(scope.row.stopTime).Format('yyyy.MM.dd') }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="timeTypeNames" label="时段" min-width="160"></el-table-column>
            <el-table-column label="排班状态" min-width="100">
              <template slot-scope="scope">
                <div class="scheduleStatus">
                  <div class="scheduleStatus_icon"></div>
                  <div class="scheduleStatus_text">停诊中</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createBy" label="操作员" min-width="100"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
            <el-table-column label="操作" min-width="80" fixed="right">
              <template slot-scope="scope">
                <div class="operation">
                  <div class="operation_btn" @click="cannelStop(scope.row.suspendId)">取消停诊</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getScheduleSuspendList, deleteScheduleSuspend } from '@/api/schedule'

  const timeTypeMap = {
    '1': '上午',
    '2': '中午',
    '3': '下午',
    '4': '晚上'
  }

  export default {
    name: 'stopSetting',
    data () {
      return {
        loading: false,
        visible: false,
        doctorId: '',
        list: []
      }
    },
    methods: {
      async getList () {
        if (!this.visible) {
          return false
        }
        this.loading = true
        const res = await getScheduleSuspendList({
          deptId: window.sessionStorage.getItem('deptId'),
          doctorId: this.doctorId
        })
        this.loading = false
        if (res.code === 200) {
          const list = res.data && res.data.map(v => {
            const isAll = ['1', '2', '3', '4'].every(type => { return [null, undefined, ''].includes(v.timeTypes) || v.timeTypes.length === 0 || v.timeTypes.includes(type) })
            v['timeTypeNames'] = isAll ? '全天' : v.timeTypes.map(type => { return timeTypeMap[type] }).join('、')
            return v
          }) || []
          this.list = list.sort((a, b) => { return a.createTime < b.createTime ? 1 : -1 })
        }
      },
      open (doctorId) {
        this.visible = true
        this.doctorId = doctorId
        this.getList()
      },
      close () {
        this.visible = false
        this.list = []
      },
      addStop () {
        this.$emit('batchStop')
      },
      cannelStop (id) {
        this.$confirm('取消停诊后该时段将恢复正常，确定取消？', '取消停诊？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'schedule_confirm'
        }).then(async () => {
          const res = await deleteScheduleSuspend({ id: id })
          if (res.code === 200) {
            if (res.data.code === 200) {
              this.$message.success('取消停诊成功')
              this.getList()
              this.$emit('deleteScheduleSuspend')
            } else {
              this.$confirm(res.data.message, '取消停诊失败', {
                confirmButtonText: '知道了',
                showCancelButton: false,
                customClass: 'schedule_confirm'
              }).then(() => {}).catch(() => {})
            }
          }
        }).catch(() => {})
      }
    }
  }
</script>

<style lang="less" scoped>
  .stopSetting /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .stopSetting /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .stopSetting /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .stopSetting /deep/ .el-dialog__body {
    padding: 0;
  }

  .stopSetting /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .content {
    padding: 16px;
  }

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .table {
    margin: 20px 0 0 0;
    width: 100%;
    border: 1px solid #EBEAEE;
  }

  .scheduleStatus {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .scheduleStatus_icon {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #F54A45;
  }

  .scheduleStatus_text {
    margin: 0 0 0 6px;
  }

  .operation {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .operation_btn {
    font-size: 14px;
    color: #1890FF;
    cursor: pointer;
  }
</style>

<style>
  .schedule_confirm .el-message-box__btns .el-button {
    padding: 8px 12px;
    font-size: 14px;
    border-radius: 2px;
  }
</style>